import React from 'react'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Formik } from 'formik'
import { Button, Form } from 'lib/ui'
import { Container } from './styled'
import { creditCardFormSchema, creditCardFormValidation, CreditCardFormValues } from './schema'
import { CommerceHubCreditCardForm, useCommerceHub } from 'lib/modules/commercehub'

export const CommerceHubAdd = () => {
  const history = useHistory()
  const intl = useIntl()
  const validation = creditCardFormValidation(intl)
  const {
    loading,
    submitForm
  } = useCommerceHub({
    onCreatePaymentTokenSuccess: () => {
      history.push('/customer/account/payment')
    }
  })

  const handleSaveCreditCard = (values: CreditCardFormValues) => {
    submitForm({
      ...values
      // ccType derived internally
    })
  }

  return (
    <Container>
      <Formik
        initialValues={{
          ...creditCardFormSchema
        }}
        validate={validation}
        onSubmit={handleSaveCreditCard}
      >
        {() => {
          return (
            <Form.Wrapper>
              <CommerceHubCreditCardForm />
              <Form.Actions.Wrapper>
                <Button
                  type='submit'
                  isLoading={loading}
                >
                  Save
                </Button>
              </Form.Actions.Wrapper>
            </Form.Wrapper>
          )
        }}
      </Formik>
    </Container>
  )
}
